import React from "react";
import ImageGallery from "react-image-gallery";
import { PreviewImage } from "../../form/core/assetUpload/defaultAssetPreview";
import { PreviewMultiImageSliderArgsType, RenderSingleImageSlideArgsType } from "./type";

function PreviewMultiImageSlider({
  autoPlay = false,
  infinite = false,
  showFullscreenButton = false,
  showThumbnails = false,
  showPlayButton = false,
  showIndex = false,
  startIndex = 0,
  onAssetRemove,
  ...props
}: PreviewMultiImageSliderArgsType) {
  const parsedAssetsList = React.useMemo(() => {
    return props.uploadedAssets.map(asset => {
      return {
        original: asset.url,
        renderItem: () => (
          <RenderSingleImageSlide
            dimension={props.dimensions}
            imageId={asset.id}
            imageUrl={asset.url}
            onAssetRemove={onAssetRemove}
            disabled={props.disabled}
          />
        )
      };
    });
  }, [props.uploadedAssets, props.dimensions, props.disabled, onAssetRemove]);

  if (props.uploadedAssets.length === 0) {
    return null;
  }

  return (
    <ImageGallery
      items={parsedAssetsList}
      autoPlay={autoPlay}
      infinite={infinite}
      showFullscreenButton={showFullscreenButton}
      showThumbnails={showThumbnails}
      showPlayButton={showPlayButton}
      showBullets={parsedAssetsList.length > 1}
      showIndex={showIndex}
      startIndex={startIndex}
    />
  );
}

export default PreviewMultiImageSlider;

function RenderSingleImageSlide(props: RenderSingleImageSlideArgsType) {
  return (
    <PreviewImage
      url={props.imageUrl}
      dimension={props.dimension}
      disabled={props.disabled}
      removeHandler={props.onAssetRemove ? () => props.onAssetRemove?.(props.imageId) : undefined}
    />
  );
}
